import React, { useMemo, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';


import { hasValidInput } from 'components/Model/ModelUtils';
import ModelType from 'components/Model/ModelType';
import ModelsContainer from 'components/Model/ModelsContainer';
import useAPI from 'services/useAPI';
import useApiCall from 'services/useApiCall';
import { useTranslation } from 'localization/useTranslation';


const createModelOption = (model) => ({ value: model, text: model.displayName || model.id, description: model.id });

const assetIdHasError = (value) => {
  if (_.isEmpty(value)) {
    return true;
  }
  return !value.match(/^[0-9a-zA-Z][0-9a-zA-Z_-]*[0-9a-zA-Z]$/g);
};

const WizardStepAssetDetail = ({ assetModels, isLoadingAssetModels, assetInfo, setAssetInfo, setIsValid }) => {
  const T = useTranslation();
  const api = useAPI();
  const [assetIdExists, setAssetIdExists] = useState(false);

  const [checkAssetId] = useApiCall({
    apiCall: api.core.getAsset,
    onSuccess: useCallback(() => {
      setAssetIdExists(true);
    }, []),
    onError: useCallback(() => {
      // TODO: we need to differentiate between 404 and other failures
      setAssetIdExists(false);
    }, [])
  });

  const assetIdError = useCallback((value) => {
    return assetIdHasError(value) || assetIdExists;
  }, [assetIdExists]);

  const assetIdErrorText = useCallback((value) => {
    const error = assetIdHasError(value);
    if (error) {
      // TODO: Translate
      return 'Asset Id format wrong';
    }
    if (assetIdExists) {
      // TODO:Translate
      return 'Asset already exist, must be unique';
    }
    return '';
  }, [assetIdExists]);

  const assetBase = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        label: T.common.assetId,
        path: 'asset.id',
        isRequired: true,
        hasError: assetIdError,
        errorText: assetIdErrorText
      },
      {
        type: ModelType.OPTIONSV2,
        label: T.common.model,
        path: 'asset.model',
        isRequired: true,
        hasError: _.isEmpty,
        options: _.map(assetModels, createModelOption),
        properties: {
          isLoading: isLoadingAssetModels,
          isTypeahead: true
        }
      },
      {
        type: ModelType.TEXT,
        label: T.common.displayname,
        path: 'asset.displayName',
        isRequired: true,
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXTAREA,
        label: T.common.description,
        path: 'asset.description',
        isRequired: false
      }
    ];
  }, [T.common.assetId, T.common.model, T.common.displayname, T.common.description, assetIdError, assetIdErrorText, assetModels, isLoadingAssetModels]);

  useEffect(() => {
    setIsValid(hasValidInput(assetInfo, assetBase));
  }, [assetBase, assetInfo, setIsValid]);

  const debouncedCheckAssetId = useMemo(() => {
    return _.debounce((id) => {
      checkAssetId(id);
    }, 1000, { trailing: true });
  }, [checkAssetId]);

  useEffect(function checkExistingAssetId () {
    debouncedCheckAssetId.cancel();
    if (!_.isEmpty(assetInfo.asset.id)) {
      debouncedCheckAssetId(assetInfo.asset.id);
    }
    return () => {
      debouncedCheckAssetId.cancel();
    };
  }, [assetInfo.asset.id, checkAssetId, debouncedCheckAssetId]);

  return <ModelsContainer models={assetBase} data={assetInfo} setData={setAssetInfo} className="pf-v5-u-w-50-on-xl" />;
};

export default WizardStepAssetDetail;
